import React from 'react'
import styled from 'styled-components'

export const Text = styled.span`
  display: ${props => !!props.block ? 'block' : 'inline'};
  margin-bottom: ${props => !!props.block ? '10px' : 'auto' };
  text-align: ${props => !!props.center ? 'center' : ''};
  font-family: 'ABChanel PB Regular S';
  font-size: ${props => !!props.small ? '10px' : !!props.xsmall ? '9px' : '10px'};
  line-height: 1.6em;
  @media only screen and (min-width: 768px) {
    font-size: ${props => !!props.small ? '10px' : !!props.xsmall ? '9px' : '14px'};
    line-height: 1.2em;
  }
`

export const ToastText = Text.extend`
  font-family: 'ABChanel PB Regular L', Arial, sans-serif;
  font-size: 16px;
  letter-spacing: -0.3px;
  text-align: center;
  color: #ffffff;
`

export const StyledToast = styled.div`
  font-family: HelveticaNeue, Helvetica, Arial;
  .toast-backdrop-clickarea {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(255, 255, 255, 0.3);
    z-index: 0;
  }
  .toast-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0);
    z-index: 1000;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding-top: 50px;
    padding-bottom: 100px;
  }
  .toast-container {
    position: relative;
    margin: auto;
    top: 50%;
    transform: translateY(-50%);
    padding: 38px 0;
    height: 100px;
    width: 90vw;
    max-width: '900px';
    background-color: rgba(0, 0, 0, 0.9);;
    color: black;
    border: 1px solid black;
    @media only screen and (min-width: 768px) {
      padding: 40px 50px 30px;
    }
    a {
      color: black;
    }
    ul {
      margin-left: 0;
      padding-left: 1.5em;
    }
  }
`

class Toast extends React.Component {
  _timeout = null
  state = {
    show: false
  }

  open = () => {
    this.setState({ show: true }, () => {
      this._timeout = setTimeout(() => this.setState({ show: false }), 3000)
    })
  }

  close = () => {
    clearTimeout(this._timeout)
    this.setState({ show: false })
  }

  componentWillUnmount() {
    this.close()
  }

  render() {
    const { children, body, className = '', ...others } = this.props
    return this.state.show &&
      <StyledToast>
        <div className="toast-backdrop" onClick={this.close}>
          <div className="toast-backdrop-clickarea"></div>
          <div className={`toast-container ${className}`} {...others}>
            <div className={`toast-body`}>
              {body ? <ToastText block center>{body}</ToastText> : children}
            </div>
          </div>
        </div>
      </StyledToast>
  }
}

export default Toast



// WEBPACK FOOTER //
// ./src/components/Toast.js